(function () {
  if (window.variantMediaGalleryGroupsLoaded) return;

  window.variantMediaGalleryGroupsLoaded = true;

  var gallerySelector = 'media-gallery[data-variant-media-groups], media-gallery[data-scroll-to-variant-featured-on-select="true"]';
  var galleryState = new WeakMap();
  var lastVariantUpdate = new WeakMap();
  var pubsubSubscribed = false;
  var DEBUG = window.VARIANT_MEDIA_GALLERY_DEBUG !== false;

  function log() {
    if (!DEBUG) return;

    var args = Array.prototype.slice.call(arguments);
    args.unshift('[vma-gallery]');
    console.log.apply(console, args);
  }

  function describeMedia(el) {
    if (!el) return null;

    return {
      id: el.dataset.mediaId,
      group: el.dataset.variantMediaGroup || 'default',
      defaultMedia: el.hasAttribute('data-variant-media-default'),
      hidden: el.hasAttribute('hidden'),
      type: el.dataset.mediaType
    };
  }

  function describeVisibleMedia(gallery) {
    return getVisibleMedia(gallery).map(describeMedia);
  }

  function normalizeId(value) {
    if (value === null || value === undefined) return '';
    return String(value);
  }

  function parseVariantMediaMap(gallery) {
    var mapScript = gallery.querySelector('script[data-variant-media-map]');
    if (!mapScript) return {};

    try {
      return JSON.parse(mapScript.textContent || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function refreshGalleryState(gallery) {
    galleryState.set(gallery, {
      map: parseVariantMediaMap(gallery)
    });
  }

  function getGalleryState(gallery) {
    var state = galleryState.get(gallery);

    if (!state) {
      refreshGalleryState(gallery);
      state = galleryState.get(gallery);
    }

    return state;
  }

  function getGalleryForm(gallery) {
    var formId = gallery.getAttribute('form');
    return formId ? document.getElementById(formId) : null;
  }

  function hasVariantMediaGroups(gallery) {
    return gallery.hasAttribute('data-variant-media-groups');
  }

  function variantFeaturedMediaFirst(gallery) {
    return gallery.dataset.variantFeaturedMediaFirst !== 'false';
  }

  function scrollToVariantFeaturedOnSelect(gallery) {
    return gallery.dataset.scrollToVariantFeaturedOnSelect === 'true';
  }

  function getFormVariantId(gallery) {
    var form = getGalleryForm(gallery);
    var input = form ? form.querySelector('[name="id"]') : null;
    return normalizeId(input ? input.value : gallery.dataset.selectedVariantId);
  }

  function shouldAcceptVariantChange(gallery, variant) {
    var formVariantId = getFormVariantId(gallery);
    var eventVariantId = normalizeId(variant && variant.id);

    if (formVariantId && eventVariantId && formVariantId !== eventVariantId) {
      log('variantChange:ignore-mismatch', {
        galleryId: gallery.id,
        formVariantId: formVariantId,
        eventVariantId: eventVariantId
      });
      return false;
    }

    return true;
  }

  function getVariantMediaGroupFromVariant(variant, map) {
    if (!variant) return '';

    var variantId = normalizeId(variant.id);
    var featuredMedia = variant.featured_media || variant.featuredMedia || variant.featured_image || variant.featuredImage;
    var mediaId = featuredMedia && featuredMedia.id;

    if (mediaId) return normalizeId(mediaId);
    if (variantId && Object.prototype.hasOwnProperty.call(map, variantId)) return normalizeId(map[variantId]);

    return '';
  }

  function getVariantMediaGroupFromForm(gallery) {
    var form = getGalleryForm(gallery);
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = normalizeId(variantInput ? variantInput.value : gallery.dataset.selectedVariantId);
    var map = getGalleryState(gallery).map;

    if (variantId && Object.prototype.hasOwnProperty.call(map, variantId)) {
      return normalizeId(map[variantId]);
    }

    return '';
  }

  function getGroupedItems(gallery) {
    return Array.prototype.slice.call(
      gallery.querySelectorAll('.product__media[data-variant-media-group], .product__thumbnail[data-variant-media-group]')
    );
  }

  function getVisibleMedia(gallery) {
    var selector = hasVariantMediaGroups(gallery)
      ? '.product__media[data-media-id][data-variant-media-group]:not([hidden])'
      : '.product__media[data-media-id]:not([hidden])';

    return Array.prototype.slice.call(gallery.querySelectorAll(selector));
  }

  function getVisibleThumbnails(gallery) {
    var selector = hasVariantMediaGroups(gallery)
      ? '.product__thumbnail[data-media-id][data-variant-media-group]:not([hidden])'
      : '.product__thumbnail[data-media-id]:not([hidden])';

    return Array.prototype.slice.call(gallery.querySelectorAll(selector));
  }

  function itemMatchesGroup(item, mediaGroupId) {
    var itemGroupId = normalizeId(item.dataset.variantMediaGroup);

    if (!itemGroupId) return true;
    if (!mediaGroupId) return true;

    return itemGroupId === mediaGroupId;
  }

  function isDefaultVariantMedia(item) {
    return item.hasAttribute('data-variant-media-default');
  }

  function setItemHidden(item, hidden) {
    if (hidden) {
      item.setAttribute('hidden', '');
    } else {
      item.removeAttribute('hidden');
    }
  }

  function updateCurrentThumbnail(gallery, activeMediaId) {
    var selector = hasVariantMediaGroups(gallery)
      ? '.product__thumbnail[data-media-id][data-variant-media-group]'
      : '.product__thumbnail[data-media-id]';
    var thumbnails = gallery.querySelectorAll(selector);

    thumbnails.forEach(function (thumbnail) {
      var isCurrent = normalizeId(thumbnail.dataset.mediaId) === normalizeId(activeMediaId);
      thumbnail.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  function updateThumbnailContainer(gallery) {
    var thumbnailContainer = gallery.querySelector('.product__thumbnails');
    if (!thumbnailContainer) return;

    thumbnailContainer.hidden = getVisibleThumbnails(gallery).length <= 1;
  }

  function findTargetMediaElement(gallery, mediaGroupId) {
    if (!mediaGroupId) return null;

    var mediaItems = gallery.querySelectorAll('.product__media[data-media-id]');

    for (var i = 0; i < mediaItems.length; i++) {
      var media = mediaItems[i];

      if (normalizeId(media.dataset.mediaId) === normalizeId(mediaGroupId)
        || normalizeId(media.dataset.variantMediaGroup) === normalizeId(mediaGroupId)) {
        return media;
      }
    }

    return null;
  }

  function findVariantFeaturedMedia(gallery, visibleMedia, mediaGroupId, preferVariantFeatured) {
    var targetMedia = findTargetMediaElement(gallery, mediaGroupId);

    if (targetMedia) return targetMedia;

    if (!visibleMedia.length) return null;
    if (!mediaGroupId) return visibleMedia[0];

    var match = visibleMedia.find(function (media) {
      return normalizeId(media.dataset.variantMediaGroup) === normalizeId(mediaGroupId)
        || normalizeId(media.dataset.mediaId) === normalizeId(mediaGroupId);
    });

    if (match) return match;

    if (preferVariantFeatured) {
      var nonDefault = visibleMedia.find(function (media) {
        return !isDefaultVariantMedia(media);
      });

      if (nonDefault) return nonDefault;
    }

    return visibleMedia[0];
  }

  function eagerLoadMediaElement(mediaEl) {
    if (!mediaEl) return;

    mediaEl.querySelectorAll('img').forEach(function (img) {
      if (img.loading === 'lazy') {
        img.loading = 'eager';
      }
    });
  }

  function shouldActivateVariantFeatured(gallery, options) {
    if (variantFeaturedMediaFirst(gallery)) return true;
    if (!scrollToVariantFeaturedOnSelect(gallery)) return false;

    return !!(options && options.scroll);
  }

  function scrollToActiveMedia(gallery, activeMedia, activeMediaId) {
    if (!activeMedia) {
      log('scroll:skip', { reason: 'no-active-media' });
      return 'none';
    }

    activeMedia.removeAttribute('hidden');

    var slider = gallery.querySelector('slider-element');
    var sliderIndex = -1;

    if (slider) {
      if (typeof slider.reset === 'function') {
        slider.reset();
      }

      if (typeof slider.itemsToShow !== 'undefined') {
        sliderIndex = slider.itemsToShow.indexOf(activeMedia);
      }
    }

    log('scroll:target', {
      activeMedia: describeMedia(activeMedia),
      activeMediaId: activeMediaId,
      sliderIndex: sliderIndex,
      sliderPage: sliderIndex >= 0 ? sliderIndex + 1 : null,
      itemsToShow: slider ? slider.itemsToShow.map(describeMedia) : []
    });

    // Phones / tablets: the gallery is a sideways slider above the buy box. scrollIntoView would also scroll the page up
    // to it, so a colour picked further down jumps the shopper back to the photos. Move only the slider, straight to
    // the variant's image.
    if (slider && slider.scrollWidth > slider.clientWidth) {
      slider.scrollTo({
        left: slider.scrollLeft + activeMedia.getBoundingClientRect().left - slider.getBoundingClientRect().left,
        behavior: 'instant'
      });
      return 'slider';
    }

    activeMedia.scrollIntoView({
      inline: 'center',
      block: 'nearest',
      behavior: 'auto'
    });

    if (slider && sliderIndex >= 0 && typeof slider.select === 'function') {
      slider.select(sliderIndex + 1, true);
      return 'scrollIntoView+select';
    }

    return 'scrollIntoView';
  }

  function updateGallery(gallery, mediaGroupId, options) {
    options = options || {};
    var items = getGroupedItems(gallery);
    var shouldScroll = options.scroll;
    var preferVariantFeatured = shouldActivateVariantFeatured(gallery, options);
    var activeMedia;
    var activeMediaId;
    var scrollMethod = 'none';

    log('update:start', {
      pass: options._pass || 'direct',
      galleryId: gallery.id,
      mediaGroupId: mediaGroupId,
      shouldScroll: shouldScroll,
      preferVariantFeatured: preferVariantFeatured,
      selectedVariantId: gallery.dataset.selectedVariantId,
      beforeVisible: describeVisibleMedia(gallery)
    });

    if (hasVariantMediaGroups(gallery)) {
      if (!items.length) {
        log('update:abort', { reason: 'no-grouped-items' });
        return;
      }

      items.forEach(function (item) {
        setItemHidden(item, !itemMatchesGroup(item, mediaGroupId));
      });
    }

    var visibleMedia = getVisibleMedia(gallery);

    if (hasVariantMediaGroups(gallery) && !visibleMedia.length && mediaGroupId) {
      log('update:fallback-unhide-all', { mediaGroupId: mediaGroupId });

      items.forEach(function (item) {
        setItemHidden(item, false);
      });
      visibleMedia = getVisibleMedia(gallery);
    }

    if (preferVariantFeatured) {
      activeMedia = findVariantFeaturedMedia(gallery, visibleMedia, mediaGroupId, true);
    } else {
      activeMedia = visibleMedia[0];
    }

    activeMediaId = activeMedia ? activeMedia.dataset.mediaId : '';

    log('update:resolved', {
      activeMedia: describeMedia(activeMedia),
      targetLookup: describeMedia(findTargetMediaElement(gallery, mediaGroupId)),
      afterVisible: describeVisibleMedia(gallery)
    });

    if (activeMedia) {
      eagerLoadMediaElement(activeMedia);
    }

    updateCurrentThumbnail(gallery, activeMediaId);
    updateThumbnailContainer(gallery);

    if (shouldScroll) {
      scrollMethod = scrollToActiveMedia(gallery, activeMedia, activeMediaId);
    }

    log('update:done', { activeMediaId: activeMediaId, scrollMethod: scrollMethod });

    gallery.dispatchEvent(new CustomEvent('variant-media-gallery:update', {
      detail: {
        mediaGroupId: mediaGroupId,
        mediaId: activeMediaId
      }
    }));
  }

  function scheduleGalleryUpdate(gallery, mediaGroupId, options) {
    options = options || {};
    refreshGalleryState(gallery);

    var shouldScroll = !!options.scroll;
    var token = (gallery._vmaScheduleToken || 0) + 1;
    gallery._vmaScheduleToken = token;

    log('schedule:start', {
      token: token,
      galleryId: gallery.id,
      mediaGroupId: mediaGroupId,
      shouldScroll: shouldScroll
    });

    function finalize(pass) {
      if (gallery._vmaScheduleToken !== token) {
        log('schedule:skip-stale', { token: token, current: gallery._vmaScheduleToken, pass: pass });
        return;
      }

      updateGallery(gallery, mediaGroupId, Object.assign({}, options, { _pass: pass }));

      log('schedule:done', { token: token, pass: pass });
    }

    if (shouldScroll) {
      window.setTimeout(function () {
        finalize('post-swap');
      }, 80);
    } else {
      finalize('immediate');
    }
  }

  function updateGalleryFromForm(gallery, options) {
    var mediaGroupId = getVariantMediaGroupFromForm(gallery);
    var form = getGalleryForm(gallery);
    var input = form ? form.querySelector('[name="id"]') : null;

    log('updateFromForm', {
      galleryId: gallery.id,
      mediaGroupId: mediaGroupId,
      formVariantId: input ? input.value : null
    });

    scheduleGalleryUpdate(gallery, mediaGroupId, options || {});
  }

  function updateGalleriesFromVariant(variant, options) {
    var variantId = normalizeId(variant && variant.id);

    if (!variantId) {
      log('variantChange:skip', { reason: 'no-variant-id' });
      return;
    }

    log('variantChange', {
      variantId: variantId,
      featuredMediaId: getVariantMediaGroupFromVariant(variant, {}),
      options: options
    });

    document.querySelectorAll(gallerySelector).forEach(function (gallery) {
      var map = getGalleryState(gallery).map;

      if (hasVariantMediaGroups(gallery) && !Object.prototype.hasOwnProperty.call(map, variantId)) {
        log('variantChange:skip-gallery', { galleryId: gallery.id, variantId: variantId });
        return;
      }

      if (!shouldAcceptVariantChange(gallery, variant)) {
        return;
      }

      var dedupeKey = variantId + ':' + (options && options.scroll ? 'scroll' : 'static');
      var now = Date.now();
      var last = lastVariantUpdate.get(gallery);

      if (last && last.key === dedupeKey && now - last.time < 200) {
        log('variantChange:dedupe', { galleryId: gallery.id, variantId: variantId });
        return;
      }

      lastVariantUpdate.set(gallery, { key: dedupeKey, time: now });

      gallery.dataset.selectedVariantId = variantId;
      scheduleGalleryUpdate(gallery, getVariantMediaGroupFromVariant(variant, map), options || {});
    });
  }

  function bindVariantPickerClicks(gallery) {
    if (!scrollToVariantFeaturedOnSelect(gallery)) return;

    var sectionId = gallery.dataset.sectionId;
    var productId = gallery.dataset.productId;
    var pickerSelector = '#VariantPicker-' + sectionId + '-' + productId + ', #VariantPicker-' + sectionId + '-' + productId + '-sticky';

    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      if (picker.dataset.variantFeaturedScrollBound === 'true') return;

      picker.dataset.variantFeaturedScrollBound = 'true';
      picker._vmaCheckedBeforePointer = null;

      picker.addEventListener('pointerdown', function (event) {
        var input = event.target.closest('input[type="radio"]');
        if (!input) return;

        picker._vmaCheckedBeforePointer = picker.querySelector('input[type="radio"]:checked');

        log('picker:pointerdown', {
          galleryId: gallery.id,
          value: input.value,
          wasChecked: picker._vmaCheckedBeforePointer === input
        });
      }, true);

      picker.addEventListener('click', function (event) {
        var input = event.target.closest('input[type="radio"]');
        var checkedBefore = picker._vmaCheckedBeforePointer;

        picker._vmaCheckedBeforePointer = null;

        if (!input || !input.checked) return;

        if (checkedBefore !== input) {
          log('picker:new-color', {
            galleryId: gallery.id,
            value: input.value
          });
          return;
        }

        log('picker:reclick', {
          galleryId: gallery.id,
          inputId: input.id,
          value: input.value
        });

        updateGalleryFromForm(gallery, { scroll: true });
      });
    });
  }

  function bindGallery(gallery) {
    var form;

    if (gallery.dataset.variantMediaGalleryBound === 'true') return;

    gallery.dataset.variantMediaGalleryBound = 'true';
    refreshGalleryState(gallery);

    log('bind', {
      galleryId: gallery.id,
      scrollOnSelect: scrollToVariantFeaturedOnSelect(gallery),
      featuredFirst: variantFeaturedMediaFirst(gallery),
      hasGroups: hasVariantMediaGroups(gallery)
    });

    form = getGalleryForm(gallery);

    if (form) {
      form.addEventListener('change', function () {
        if (scrollToVariantFeaturedOnSelect(gallery)) return;

        updateGalleryFromForm(gallery, { scroll: variantFeaturedMediaFirst(gallery) });
      });
    }

    bindVariantPickerClicks(gallery);
    updateGallery(gallery, getVariantMediaGroupFromForm(gallery), { scroll: false, _pass: 'init' });
  }

  function initGalleries() {
    var galleries = document.querySelectorAll(gallerySelector);
    log('init', { count: galleries.length });
    galleries.forEach(bindGallery);
  }

  function subscribeToThemePubsub() {
    if (pubsubSubscribed) return;

    if (!window.theme || !theme.pubsub || !theme.pubsub.PUB_SUB_EVENTS || !theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      window.setTimeout(subscribeToThemePubsub, 100);
      return;
    }

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
      var payload = event && event.data ? event.data : event;
      log('pubsub:variantChange', { variantId: payload && payload.variant && payload.variant.id });
      updateGalleriesFromVariant(payload && payload.variant, { scroll: true, _source: 'pubsub' });
    });

    pubsubSubscribed = true;
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && (event.detail.variant || event.detail);
    log('event:variant:change', { variantId: variant && variant.id });
    updateGalleriesFromVariant(variant, { scroll: true, _source: 'variant:change' });
  });

  document.addEventListener('variantChange', function (event) {
    var variant = event.detail && (event.detail.variant || event.detail);
    log('event:variantChange', { variantId: variant && variant.id });
    updateGalleriesFromVariant(variant, { scroll: true, _source: 'variantChange' });
  });

  document.addEventListener('shopify:section:load', initGalleries);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

  subscribeToThemePubsub();
})();
